import { CMSNotification as e, deserializeDatesInObject as t, getI18n as n, useNotificationStore as r, useSockets as i } from "@editor/ui-utils";
import { reactive as a, watch as o } from "vue";
//#region src/composables/useLock.ts
var s = (e) => `/locking/${e.replaceAll("/", "-")}`, c = (e, t) => {
	if (e) return e;
	if (!t || typeof t != "object" || !("_id" in t)) return;
	let { _id: n } = t;
	return typeof n == "string" ? n : void 0;
}, l = 2e4, u = {
	notificationLockGranted: "locks.lockBroken",
	notificationButtonBreakLock: "locks.break",
	notificationLockedYourself: "locks.lockedByYou",
	notificationLockedOthers: "locks.lockedBy"
}, d = (d, f, p, m = !0, h) => {
	let g = p ?? u, _ = i().socket(s(d)), v = [], y = [], b = !1, x = a({
		initialized: !1,
		resourceUuid: "",
		async init(e) {
			x.resourceUuid && x.resourceUuid !== e && (_.emit("releaseLock", x.resourceUuid), _.emit("unwatch", [x.resourceUuid]), x.lockUuid = void 0, x.lockInfo = void 0), b = !1, x.resourceUuid = e, x.initialized = !0, _.emit("watch", [x.resourceUuid]);
		},
		teardown() {
			b = !1, _.emit("releaseLock", x.resourceUuid), _.emit("unwatch", [x.resourceUuid]), x.lockUuid = void 0, x.lockInfo = void 0, x.resourceUuid = "", v = [], y = [];
		},
		requestLock(e = !1) {
			e && (b = !0), _.emit("requestLock", {
				lockUuid: x.lockUuid,
				force: e,
				resourceUuid: x.resourceUuid
			});
		},
		broadcastUpdate(e) {
			if (!x.lockUuid) {
				console.warn("Trying to broadcast document update without lock!");
				return;
			}
			_.emit("contentUpdate", {
				resourceUuid: x.resourceUuid,
				lockUuid: x.lockUuid,
				document: e
			});
		},
		releaseLock() {
			if (!x.lockUuid) {
				console.warn("Trying to release lock without lock!");
				return;
			}
			_.emit("releaseLock", x.resourceUuid);
		},
		clearNotification() {
			x.lockNotification && x.lockNotification();
		},
		onDocumentUpdate(e) {
			return v.push(e), () => {
				v = v.filter((t) => t !== e);
			};
		},
		onExternalChange(e) {
			return y.push(e), () => {
				y = y.filter((t) => t !== e);
			};
		}
	}), { showNotification: S } = r(), C = n(), w = () => {
		x.lockNotification && x.lockNotification();
	}, T = (e) => {
		let t = e[x.resourceUuid];
		t && (x.lockInfo = t);
	}, E = (e) => {
		e.resourceUuid === x.resourceUuid && (b = !1, x.lockUuid = e.lockUuid, x.lockInfo = void 0, w());
	}, D = (e) => {
		e.resourceUuid === x.resourceUuid && (x.lockInfo = e);
	}, O = async ({ resourceUuid: e, document: n }) => {
		if (c(e, n) !== x.resourceUuid) return;
		let r = t(n);
		for (let e of v) await e(r);
	}, k = async (e) => {
		if (!(e.resourceUuid !== x.resourceUuid || e.resourceType !== d)) for (let e of y) await e();
	}, A = () => {
		console.warn("[lock] sessionLost; reloading", {
			resourceType: d,
			resourceUuid: x.resourceUuid || void 0,
			socketId: _.id,
			lockUuid: x.lockUuid
		});
		try {
			window.sessionStorage.setItem("ctf.lock.sessionLostReloadAt", (/* @__PURE__ */ new Date()).toISOString());
		} catch {}
		window.location.reload();
	}, j = 0, M = () => {
		j++;
		let e = j > 1;
		x.resourceUuid && _.emit("watch", [x.resourceUuid]), e && console.warn("[lock] reconnected, watching", {
			resourceType: d,
			resourceUuid: x.resourceUuid || void 0,
			socketId: _.id,
			lockUuidWas: x.lockUuid,
			reconnectCount: j - 1
		});
	};
	_.on("watchConfirmed", T), _.on("lockGranted", E), _.on("lockChanged", D), _.on("contentUpdate", O), _.on("externalContentChange", k), _.on("sessionLost", A), _.on("connect", M);
	let N = o([
		f,
		() => !!x.resourceUuid,
		() => !!x.lockUuid
	], ([e, t, n]) => {
		e && t && !n && !b && x.requestLock();
	}), P = o(() => x.lockInfo, async (t, n) => {
		if (w(), !(!t || t?.resourceUuid !== x.resourceUuid || t?.resourceType !== d)) if (t.locked) {
			if (t.isOwnLock && t.lockUuid && t.lockUuid === x.lockUuid) {
				x.lockInfo = void 0;
				return;
			}
			console.warn(t.isOwnLock ? "[lock] locked: own-after-grant" : "[lock] locked: other-user", {
				resourceType: d,
				resourceUuid: x.resourceUuid,
				socketId: _.id,
				incomingLockUuid: t.lockUuid,
				heldLockUuid: x.lockUuid,
				isOwnLock: t.isOwnLock
			}), x.lockUuid = void 0, x.lockNotification = S(new e(t.isOwnLock ? C.t(g.notificationLockedYourself.toString()) : C.t(g.notificationLockedOthers.toString()) + " " + (t.ownerName || "<unknown>"), "info", {
				dismissible: !0,
				timeout: null,
				callbackLabel: C.t(g.notificationButtonBreakLock.toString()),
				callbackDataQa: "break-lock",
				callbackNoDismiss: !0,
				callbackFunc: m ? async () => {
					x.requestLock(!0), await h?.();
				} : void 0
			}));
		} else x.lockUuid &&= void 0, n && n.locked && (S(new e(C.t(g.notificationLockGranted.toString()), "positive")), await h?.()), n?.locked && f.value && x.resourceUuid && !x.lockUuid && x.requestLock();
	}, { deep: !0 }), F, I = () => {
		F &&= (clearInterval(F), void 0);
	}, L = () => {
		I(), F = setInterval(() => {
			if (!x.resourceUuid || !x.lockUuid) {
				I();
				return;
			}
			_.emit("refreshLock", {
				resourceUuid: x.resourceUuid,
				lockUuid: x.lockUuid
			});
		}, l);
	}, R = o(() => x.lockUuid, (e) => {
		e ? L() : I();
	}, { immediate: !0 });
	return x.clearInitializedResources = () => {
		_.off("watchConfirmed", T), _.off("lockGranted", E), _.off("lockChanged", D), _.off("contentUpdate", O), _.off("externalContentChange", k), _.off("sessionLost", A), _.off("connect", M), P(), N(), R(), I();
	}, x;
}, f = (e, n) => {
	let r = i().socket(s(e)), l = [], u = a({
		locks: {},
		async init() {
			r.emit("watch", n.value);
		},
		onDocumentUpdate(e) {
			return l.push(e), () => {
				l = l.filter((t) => t !== e);
			};
		},
		teardown() {
			l = [], r.emit("unwatch", n.value);
		}
	}), d = (e) => {
		u.locks = e;
	}, f = (e) => {
		u.locks[e.resourceUuid] = e;
	}, p = async ({ resourceUuid: e, document: r }) => {
		let i = c(e, r);
		if (!i || !n.value.includes(i)) return;
		let a = t(r);
		for (let e of l) await e(a);
	}, m = () => {
		window.location.reload();
	}, h = () => {
		n.value && r.emit("watch", n.value);
	};
	r.on("watchConfirmed", d), r.on("lockChanged", f), r.on("contentUpdate", p), r.on("sessionLost", m), r.on("connect", h);
	let g = o(n, (e, t) => {
		t && t.length && (r.emit("unwatch", t), u.locks = {}), r.emit("watch", e);
	});
	return u.clearInitializedResources = () => {
		r.off("watchConfirmed", d), r.off("lockChanged", f), r.off("contentUpdate", p), r.off("sessionLost", m), r.off("connect", h), g();
	}, u;
}, p = {
	en: { locks: {
		lockedBy: "The document is locked by",
		break: "Break lock",
		lockedByYou: "The form is locked by yourself in another tab.",
		lockRemoved: "Lock removed",
		contentChanged: "The page was updated by the system. It cannot be saved in this tab anymore.",
		refresh: "Refresh",
		lockBroken: "You can now edit this document."
	} },
	de: { locks: {
		lockedBy: "Das Dokument ist gesperrt von",
		break: "Entsperren",
		lockedByYou: "Das Formular wird von dir selbst in einem anderen Tab gesperrt.",
		lockRemoved: "Sperre entfernt",
		contentChanged: "Die Seite wurde vom System aktualisiert. Sie kann in diesem Tab nicht mehr gespeichert werden.",
		refresh: "Aktualisieren",
		lockBroken: "Du kannst dieses Dokument jetzt bearbeiten."
	} }
};
//#endregion
export { s as getResourceChannelName, p as messages, f as useListLocking, d as useSingleResourceLocking };

//# sourceMappingURL=index.es.js.map